module.exports = __webpack_public_path__ + "img/success.45dc2015.svg";